import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=661fa435&scoped=true&"
import script from "./Details.vue?vue&type=script&setup=true&lang=js&"
export * from "./Details.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661fa435",
  null
  
)

export default component.exports